import { SSOUrlRequest, SSOUrlResponse } from "@/types/dosespot";

import { requestData } from "@/api/api-config";

// Patient-scoped SSO always runs a DoseSpot create/update (backend allows up to
// 30s for that call alone, plus token mint + network). Default ky timeout is
// 20s, which aborts successful-but-slow launches — keep the client above the
// backend ceiling with headroom.
const DOSESPOT_SSO_TIMEOUT_MS = 45_000;

/**
 * Generate a Single Sign-On URL for DoseSpot Jumpstart integration.
 *
 * If patientId is provided, current demographics are always synced to DoseSpot
 * (create or update) before generating the SSO URL, so e-prescribe has the
 * latest chart data and can deep-link to the patient.
 */
export async function generateDoseSpotSSOUrl(
  request: SSOUrlRequest,
): Promise<SSOUrlResponse | null> {
  return await requestData<SSOUrlResponse>(
    "dosespot/sso",
    "post",
    {
      json: request,
    },
    false,
    DOSESPOT_SSO_TIMEOUT_MS,
  );
}
